import { Box } from '@material-ui/core';
import { formatMoney } from '@nemuru-eng/js-api-client';

import { StoredCart } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/types/StoredCart';
import { ActionDialog } from '@/components/shared/components/ActionDialog';
import { CustomDivider } from '@/components/shared/components/CustomDivider';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

interface RemoveStoredCartDialogProps {
  opened: boolean;
  setOpened: (value: boolean) => void;
  removeCartFromRepository: () => void;
  selectedCart: StoredCart;
}

export const RemoveStoredCartDialog = ({
  opened,
  setOpened,
  removeCartFromRepository,
  selectedCart,
}: RemoveStoredCartDialogProps) => {
  return (
    <ActionDialog
      opened={opened}
      setOpened={setOpened}
      handleClose={() => setOpened(false)}
      Title={<Text tId={'REMOVE_CART'} />}
      Description={<Text tId={'REMOVE_CART_DESCRIPTION'} />}
      onSubmit={removeCartFromRepository}
      MainButton={<Text tId={'REMOVE'} />}
    >
      <Box display={'flex'} flexDirection={'column'} gridGap={4} pt={2}>
        {selectedCart.cart.items.map((item) => (
          <Font variant="body2" color="textSecondary">
            <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} gridGap={6}>
              <Box>
                {item.data.units} x {item.data.description}
              </Box>
              <strong>
                {formatMoney({
                  value: Number(item.data.price),
                  currency: selectedCart.cart.currency,
                })}
              </strong>
            </Box>
          </Font>
        ))}
        <CustomDivider />
        <Font variant="body2" color="textSecondary" style={{ textAlign: 'right' }}>
          <Box gridGap={8} display={'flex'} justifyContent={'flex-end'}>
            <Text tId={'TOTAL'} />:
            <strong>
              {formatMoney({
                value: selectedCart.cart.items.reduce((acc, item) => (acc += Number(item.price)), 0),
                currency: selectedCart.cart.currency,
              })}
            </strong>
          </Box>
        </Font>
      </Box>
    </ActionDialog>
  );
};
